var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col"
  }, [_c("div", {
    staticClass: "section2 flex-row justify-between"
  }, [_c("div", {
    staticClass: "outer4 flex-col",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticClass: "imgBack",
    attrs: {
      src: require("../../assets/images/back.png"),
      alt: ""
    }
  })]), _c("span", {
    staticClass: "txt1"
  }, [_vm._v("MG ZS EV MCE")])]), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "box2 flex-col"
  }, [_c("div", {
    staticClass: "bd1 flex-col"
  }, [_c("img", {
    staticClass: "pic1",
    attrs: {
      referrerpolicy: "no-referrer",
      src: "https://tpage.soimt.com/APP/SNS/brochure_ev.png"
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };